import { createTable } from 'core/Packages';

const createDataGrid = createTable;
export { createDataGrid };
